import './App.css';
import Header from './Header';
import FirebaseFunction from './FirebaseFunction';
import UserForm from './UserForm';


const App =() => { 

  return ( 
 
    <div className="App">
    <Header />
    <UserForm />
    </div>
   
  );
}


export default App;
